/*
 * @Description: 
 * @Author: kangkang
 * @Date: 2024-05-12 14:12:45
 * @LastEditTime: 2024-05-12 16:15:47
 * @LastEditors: kangkang
 * @Reference: 
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from './plugins/axios'
import api from './api';
import regular from './plugins/regular'
import utils from '@/plugins/utils'
import moment from 'moment';
import "./plugins/vant"
import 'amfe-flexible'
import VConsole from 'vconsole';

// const vConsole = new VConsole();


Vue.config.productionTip = false
Vue.prototype.$http = axios;
Vue.prototype.$utils = utils;
Vue.prototype.$api = api;
Vue.prototype.$regular = regular;
Vue.prototype.$moment  = moment;
Vue.prototype.$domain = process.env.VUE_APP_API_URL;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
